<template>
  <v-container>
    <h1 v-if="this.browseList.length == 0 && this.currentlyLoading == false" style="color: white;">
      Sorry, we couldn't find anything
    </h1>
    <v-row class="d-flex" no-gutters>
      <v-overlay absolute v-if="currentlyLoading" opacity="0.5">
        <v-progress-circular indeterminate size="128" absolute v-bind:color="config.primary">
        </v-progress-circular>
      </v-overlay>
      <v-card
        :dark="config.dark_background"
        :color="config.background_dark_slight"
        v-bind:key="index"
        v-for="(item, index) in browseList"
        class="elevation-4 mr-2 ml-2 mt-2 mb-2 hover-card"
        max-width="240"
        max-height="400"
        @click="moreInfo(item)"
        style="min-width: 240; height: 400;"
      >
        <v-img
          contain
          style="border-radius: 50%;"
          lazy-src=""
          :src="item.image"
          crossorigin="anonymous"
          height="auto"
        >
        </v-img>
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="title mb-1">
              <v-tooltip open-delay="500" v-if="item.private" top v-bind:color="config.special_1">
                <template v-slot:activator="{ on }">
                  <!-- Activate toolbar if you hover over it -->
                  <v-icon class="mb-1" left v-bind:color="config.special_1" v-on="on"
                    >mdi-lock-check</v-icon
                  >
                </template>
                <h3>Only you can view and edit this chip</h3>
              </v-tooltip>
              {{ item.name }}
            </v-list-item-title>
            <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-spacer></v-spacer>
        <v-card-actions>
          <div style="height: 30px; width: 100%;">
            <v-tooltip open-delay="100" v-if="itemInLibrary(item._id)" top :color="config.alert">
              <template v-slot:activator="{ on }">
                <!-- Activate toolbar if you hover over it -->
                <v-icon class="mx-2" left :color="config.alert" v-on="on">mdi-heart</v-icon>
              </template>
              <h3>This chip is in your favorites!</h3>
            </v-tooltip>
            <v-tooltip
              open-delay="100"
              v-if="isOwner(item) && !item.private"
              top
              :color="config.special_1"
            >
              <template v-slot:activator="{ on }">
                <!-- Activate toolbar if you hover over it -->
                <v-icon class="mx-2" left :color="config.special_1" v-on="on">mdi-account</v-icon>
              </template>
              <h3>This chip was created by you!</h3>
            </v-tooltip>
          </div>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="dialog" width="500">
        <!-- Login Prompt -->
        <modal> </modal>
      </v-dialog>
      <v-dialog v-model="info" width="450">
        <!-- Chip Info -->
        <modal>
          <template v-slot:title>
            {{ itemInfo.name }}
            <v-tooltip v-if="itemInfo.private" top v-bind:color="config.secondary">
              <template v-slot:activator="{ on }">
                <!-- Activate toolbar if you hover over it -->
                <v-icon class="ml-3" v-bind:color="config.secondary" v-on="on"
                  >mdi-lock-check</v-icon
                >
              </template>
              <h3>Only you can view and edit this chip</h3>
            </v-tooltip>
            <v-tooltip v-if="isOwner(itemInfo) || getUser.admin" top v-bind:color="config.cancel">
              <template v-slot:activator="{ on }">
                <!-- Activate toolbar if you hover over it -->
                <v-btn icon large class="ml-1" @click="deleteItem(itemInfo)" v-on="on">
                  <v-icon v-bind:color="config.cancel">mdi-delete-forever</v-icon>
                </v-btn>
              </template>
              <h3>Delete this chip forever?</h3>
            </v-tooltip>
            <v-btn class="ml-auto mr-1" elevation="0" icon @click="info = !info">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <template v-slot:text>
            <v-row no-gutters>
              <v-col cols="12">
                <div>
                  {{ itemInfo.description }}
                </div>
                <br />
              </v-col>
            </v-row>
            <div class="overlay-box">
              <img crossorigin="anonymous" :src="overlays[activeOverlay]" class="overlay-chip" />
              <img crossorigin="anonymous" :src="itemInfo.image" class="overlay-image" />
            </div>
            <v-row justify="center" class="text-center">
              <v-col cols="12" sm="2">
                <v-btn @click="switchChip('sub')" icon>
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn :color="config.secondary" @click="switchChip('reset')" elevation="0">
                  Preview {{ activeOverlay + 1 }} / {{ overlays.length }}
                </v-btn>
              </v-col>
              <v-col cols="12" sm="2">
                <v-btn @click="switchChip('add')" icon>
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </template>
          <template v-slot:actions>
            <v-flex class="d-flex mb-3">
              <v-btn
                :color="config.primary"
                :dark="config.dark_primary"
                class="ml-auto mr-auto"
                large
                elevation="0"
                @click="
                  info = !info
                  printChip(itemInfo)
                "
              >
                <span>Print</span>
                <v-icon right>mdi-printer</v-icon>
              </v-btn>
              <v-btn
                :color="config.alert"
                :dark="config.dark_primary"
                class="ml-auto mr-auto"
                large
                elevation="0"
                v-if="!itemInLibrary(itemInfo._id) && loggedIn"
                @click="
                  addToLibrary(itemInfo._id)
                  info = !info
                "
              >
                <span>Add to Favorites</span>
                <v-icon right>mdi-heart</v-icon>
              </v-btn>
              <v-btn
                :color="config.primary"
                :dark="config.dark_primary"
                class="ml-auto mr-auto"
                large
                elevation="0"
                v-if="itemInLibrary(itemInfo._id)"
                @click="
                  info = !info
                  editChip(itemInfo)
                "
              >
                <span>Edit this chip</span>
                <v-icon>mdi-circle-edit-outline</v-icon>
              </v-btn>
            </v-flex>
          </template>
        </modal>
      </v-dialog>
    </v-row>
    <v-row justify="center" class="mt-5">
      <div class="button-container-main">
        <h3 class="mt-1" :style="'color:' + config.primary_text">Page</h3>
        <div class="button-item">
          <v-btn :color="config.primary_text" icon @click="pageBack()">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </div>
        <h3 class="mt-1" :style="'color:' + config.primary_text">{{ page }} / {{ totalPages }}</h3>
        <div class="button-item">
          <v-btn :color="config.primary_text" icon @click="pageNext()">
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </div>
    </v-row>
    <v-dialog
      v-model="fsDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      :key="0"
    >
      <!-- Print Page -->
      <f-s-modal :canvas_data="itemInfo.image">
        <template v-slot:actions>
          <v-btn icon dark @click="fsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Print and Adjust</v-toolbar-title>
        </template>
      </f-s-modal>
    </v-dialog>
  </v-container>
</template>

<script>
import ItemService from '@/services/ItemService'
import LibraryService from '@/services/LibraryService'
import Modal from '@/components/Modal.vue'
import { mapGetters } from 'vuex'
import config from '@/config/config'
import { fabric } from 'fabric'
import FSModal from '@/components/FSModal.vue'

export default {
  name: 'browse',
  data() {
    return {
      browseList: [],
      userLibrary: [],
      dialog: false,
      info: false,
      itemInfo: {},
      currentlyLoading: true,
      config,
      page: 1,
      totalPages: 1,
      fsDialog: false,
      activeOverlay: 0,
      overlays: [
        require('@/assets/blackchip.svg'),
        require('@/assets/redchip.svg'),
        require('@/assets/greenchip.svg'),
        require('@/assets/bluechip.svg'),
        require('@/assets/whitechip.svg'),
      ],
    }
  },
  methods: {
    async switchChip(action) {
      switch (action) {
        case 'sub':
          if (this.activeOverlay > 0) this.activeOverlay = this.activeOverlay - 1
          break
        case 'add':
          if (this.activeOverlay < this.overlays.length - 1)
            this.activeOverlay = this.activeOverlay + 1
          break
        case 'reset':
          if (this.activeOverlay != 0) this.activeOverlay = 0
          break
      }
    },
    async printChip(item) {
      if (!this.loggedIn) {
        this.dialog = true
      } else {
        this.itemInfo = item
        this.loading = true
        this.fsDialog = true
        this.loading = false
      }
    },
    addImages(array) {
      return array.map(function(item) {
        item.image = config.backendURL + '/public/icons/' + item._id + '.png'
        return item
      })
    },
    async pageBack() {
      if (this.page > 1) {
        this.page -= 1
        this.getBrowseList(this.page)
      }
    },
    async pageNext() {
      if (this.page != this.totalPages) {
        this.page += 1
        this.getBrowseList(this.page)
      }
    },
    async deleteItem(item) {
      try {
        const sendObj = {
          itemId: item._id,
          token: this.getUser.token,
        }
        const response = await ItemService.delete(sendObj)
        this.info = false
        this.browseList = this.browseList.filter(
          (browseItem) => browseItem._id != response.data._id
        )
        this.userLibrary = this.userLibrary.filter(
          (libraryItem) => libraryItem._id != response.data._id
        )
      } catch (error) {
        this.$router.push({ name: 'home' })
        alert(error)
      }
    },
    isOwner(item) {
      if (this.getUser._id == item.user_created) {
        return true
      } else {
        return false
      }
    },
    async downloadImage(canvas_data) {
      const canvas = new fabric.StaticCanvas()
      canvas.setWidth(650)
      canvas.setHeight(650)
      await canvas.loadFromDatalessJSON(canvas_data)
      const uri = canvas.toDataURL('image/png')
      let link = document.createElement('a')
      link.download = name
      link.href = uri
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    editChip(item) {
      this.$router.push({
        name: 'create',
        params: {
          itemInfo: item,
        },
      })
    },
    getImageFromCanvas(canvas) {
      return new Promise((resolve, reject) => {
        try {
          const uri = canvas.toDataURL('image/png')
          resolve(uri)
        } catch (error) {
          reject(error)
        }
      })
    },
    async getBrowseList(page) {
      // Reload data refers to the data passed in from a response to a previous request
      try {
        this.currentlyLoading = true
        let response
        if (this.getSearchInfo == '') response = await ItemService.getPublic({ page })
        else response = await ItemService.getPublic({ page, search: this.getSearchInfo })
        const array = this.addImages(response.data.items)
        this.currentlyLoading = false
        this.browseList = array
        this.totalPages = response.data.pageCount
      } catch (error) {
        this.browseList = []
        this.$router.push({ name: 'home' })
        alert(error)
      }
    },
    getSearchDataPrivate() {
      if (this.getSearchInfo) {
        return ItemService.searchPrivate(
          {
            token: this.getUser.token,
          },
          this.getSearchInfo
        )
      } else {
        return ItemService.getPrivate({
          token: this.getUser.token,
        })
      }
    },
    async addToLibrary(itemId) {
      try {
        if (this.loggedIn) {
          const response = await LibraryService.add({
            token: this.getUser.token,
            itemId,
          })
          this.userLibrary.push(response.data)
          this.$store.dispatch('setAlert', {
            notification: `${response.data.name} has been added to your favorites`,
          })
        } else {
          this.dialog = true
        }
      } catch (error) {
        this.$store.dispatch('setAlert', error)
      }
    },
    async removeFromLibrary(itemId) {
      try {
        const response = await LibraryService.remove({
          token: this.getUser.token,
          itemId,
        })
        if (!response.error) {
          this.userLibrary = response.data
        } else {
          this.userLibrary = [{ name: response.error }]
        }
      } catch (error) {
        throw error
      }
    },
    itemInLibrary(itemId) {
      if (this.loggedIn) {
        let found = false
        this.userLibrary.forEach((item) => {
          if (item._id == itemId) {
            found = true
          }
        })
        return found
      }
    },
    async getUserLibrary() {
      try {
        if (this.loggedIn) {
          const response = await LibraryService.get({
            token: this.getUser.token,
          })
          if (!response.data.error) {
            this.userLibrary = response.data
          } else {
            return response.data.error
          }
        }
      } catch (err) {
        throw err
      }
    },
    moreInfo(item) {
      try {
        this.itemInfo = item
        this.info = true
      } catch (error) {
        throw error
      }
    },
  },
  async mounted() {
    this.getBrowseList(1)
    this.getUserLibrary()
  },
  components: {
    Modal,
    FSModal,
  },
  computed: {
    search() {
      // Constantly get searchinfo from the store
      return this.getSearchInfo
    },
    ...mapGetters({
      // The three ... distributes contents of the object throughout the computed object
      loggedIn: 'loggedIn',
      getSearchInfo: 'getSearchInfo',
      getUser: 'getUser',
    }),
  },
  watch: {
    // Watch the computed property
    search() {
      this.page = 1
      this.getBrowseList(1)
    },
  },
}
</script>

<style scoped>
.hover-card {
  cursor: pointer;
}

.positioned {
  position: relative;
}

.button-container-main {
  height: 60px;
  width: 80%;
  overflow: visible;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: flex-start;
  align-content: flex-start;
}

.button-item {
  margin-left: 12px;
  margin-right: 12px;
}

.overlay-chip {
  position: absolute;
  width: 100%;
  z-index: 2;
}

.overlay-image {
  border-radius: 50%;
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  width: 70%;
  z-index: 1;
}

.overlay-box {
  position: relative;
  height: 320px;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}
</style>
